import { Alert } from "react-bootstrap";
import { getPodadoresHandler } from "../../../../../handlers/podadores.handler";
import useWindowSize from "../../../../../hooks/useWindowSize";

const AlertEstadoSolicitud = ({ estado, podadores }) => {
  const size = useWindowSize();
  const { width } = size;

  return (
    <section className={`${width >= 640 ? "" : "mb-4"}`}>
      {estado.id == 5 && (
        <Alert variant="warning" className="m-0">
          Le informamos que su solicitud de poda ha sido recibida con éxito. Dentro de un plazo
          máximo de <b>72 horas</b>, en el horario de <b>8:00 a 14:00</b>, un inspector municipal
          realizará la visita correspondiente para evaluar la intervención requerida.
        </Alert>
      )}
      {estado.id == 10 && (
        <Alert variant="info" className="m-0">
          La solicitud esta en estado <b>{estado.estado}</b>, una vez aceptada puede seleccionar
          podador/es para realizar la tarea.
        </Alert>
      )}
      {estado.id == 2 && (
        <>
          {podadores.length == 0 ? (
            <Alert variant="primary" className="m-0">
              La solicitud fue <b>Aceptada</b>, puede continuar eligiendo podadores para realizar la
              tarea .{" "}
              <button
                className="btn btn-sm btn-primary"
                onClick={() => {
                  getPodadoresHandler();
                }}
              >
                Elegir
              </button>
            </Alert>
          ) : (
            <Alert variant="primary" className="">
              Una vez realizado la tarea solicitada, haga click en <b>" Finalizar trámite"</b>
            </Alert>
          )}
        </>
      )}
      {estado.id == 8 && (
        <Alert variant="success" className="m-0">
          La solicitud fue <b>Finalizada</b>
        </Alert>
      )}
      {estado.id == 3 && (
        <Alert variant="danger" className="m-0">
          La solicitud fue <b>Cancelada</b>
        </Alert>
      )}
    </section>
  );
};
export default AlertEstadoSolicitud;
